<template lang="pug">
    el-dialog(title="查看学员评价",width="50%",  :visible.sync='visiblekt' :append-to-body='true' :modal-append-to-body='false' style="z-index: 2007")
        <div class='Satisfaction'  v-loading.fullscreen.lock="fullscreenLoading">
            <div v-if='fullscreenLoading' class='loding'></div>
            <div class='Satisfactioninfo'>
                <strong>教练满意度</strong>
                <div class='evaluate'>
                    <span>教学态度</span>
                    <el-rate v-model="evaluateList.teachingAttitude" show-text @change='changevalue' disabled class='star'></el-rate>
                </div>
                <div class='evaluate'>
                    <span>教姿教貌教态/仪表着装</span>
                    <el-rate v-model="evaluateList.appearance" show-text @change='changevalue' disabled class='star'></el-rate>
                </div>
                <div class='evaluate'>
                    <span>课堂组织</span>
                    <el-rate v-model="evaluateList.communicate" show-text @change='changevalue' disabled class='star'></el-rate>
                </div>
                <div class='evaluate'>
                    <span>课堂效率</span>
                    <el-rate v-model="evaluateList.efficiency" show-text @change='changevalue' disabled class='star'></el-rate>
                </div>
                <div class='evaluate'>
                    <span>教学效果</span>
                    <el-rate v-model="evaluateList.skill" show-text @change='changevalue' disabled class='star'></el-rate>
                </div>
                <div class='evaluate'>
                    <span>服务态度</span>
                    <el-rate v-model="evaluateList.service" show-text @change='changevalue' disabled class='star'></el-rate>
                </div>
                <strong class='CoachEvaluation'>教练评价</strong>
                <div class='label'>
                    <span v-for="(item,index) in evaluateList.byx1List" :key='index'>{{item}}</span>
                </div>
                <div class='label1'>
                    <div>评语：{{evaluateList.evaluate}}</div>
                </div>
            </div>
        </div>

            <div class='btn'>
                el-button(@click="closeGoBack") 返 回
            </div>
</template>
<script>
export default {
  data () {
    return {
      visiblekt: false,
      value: '',
      evaluateList: {
        value: '',
        byx1List: []
      },
      fullscreenLoading: false
    }
  },
  methods: {
    changevalue () {
      console.log(this.value)
    },
    init (item) {
      // this.fullscreenLoading = true
      this.visiblekt = true
      this.evaluateList = {}
      this.$http({
        url: this.$http.adornUrl(
          '/com/devplatform/admin/modules/pxCoachEvaluation/getSelectId'
        ),
        method: 'post',
        // params: this.$http.adornParams
        data: {
          mbId: item.memberId,
          byx3: item.trainId
        }
      }).then((data) => {
        if (data.bean) {
          this.evaluateList = {}
          this.fullscreenLoading = false
          this.evaluateList = data.bean
          this.evaluateList.byx1List = this.evaluateList.tableNames
            ? this.evaluateList.tableNames.split(',')
            : []
        } else {
          this.fullscreenLoading = false
          this.evaluateList = {}
        }
      })
      // this.$http({
      //   url: this.$http.adornUrl(
      //     '/pxCoachEvaluation/px-coach-evaluation-table/list'
      //   ),
      //   method: 'get'
      //   // params: this.$http.adornParams({
      //   //   mbId: item.memberId,
      //   //   byx3: item.trainId
      //   // })
      //   // data: {
      //   //   mbId: item.memberId,
      //   //   byx3: item.trainId
      //   // }
      // }).then((data) => {
      //   if (data) {
      //     // this.evaluateList = {}
      //     // this.fullscreenLoading = false
      //     // this.evaluateList = data
      //     // this.evaluateList.byx1List = this.evaluateList.byx1.split(',')
      //   } else {
      //     // this.evaluateList = {}
      //   }
      // })
    },
    closeGoBack () {
      this.visiblekt = false
      this.fullscreenLoading = false
      this.$emit('chooseTemplate', false)
    }
  },
  watch: {
    visiblekt (val) {
      // alert(val)
      this.fullscreenLoading = val
    }
  }
}
</script>
<style>
.el-loading-mask {
  background: none;
  width: 100px;
  height: 100px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.loding {
  z-index: 2013;
  width: 100%;
  height: 100%;
  background: white;
  opacity: 0.7;
  position: absolute;
  left: 0;
  top: 0;
}
.btn {
  display: flex;
  justify-content: flex-end;
}
.Satisfaction {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
}
.el-rate {
  height: 30px;
}
.CoachEvaluation {
  margin-top: 33px;
  display: flex;
}
.label {
  padding-top: 15px;
  padding-bottom: 20px;
}
.label1 {
  padding-bottom: 20px;
}
.label span {
  display: inline-block;
  padding: 2px 10px;
  border: 1px solid #ccc;
  margin-right: 10px;
}
.Satisfactioninfo {
  width: 60%;
}
.evaluate {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.evaluate strong {
  color: rgb(8, 8, 8);
}
.evaluate span {
  color: #757575;
  /* display: inline-block;
  width: 200px; */
}
.el-rate__text {
  margin-left: 50px;
  color: #757575 !important;
}
.star {
  display: flex;
  align-items: center;
}
.el-rate__icon {
  font-size: 23px;
}
.width_label {
  width: 180px;
}
.opSetting {
  text-align: center;
  margin-top: 30px;
}
.spacing {
  margin-top: 10px;
}
.font_label {
  font-weight: bold;
  font-size: 18px;
}

.el-radio.is-bordered {
  width: 140px;
  padding: 12px 20px 0 10px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 40px;
}

/* 分页样式 */
.el-pager li {
  padding: 0 4px;
  font-size: 13px;
  min-width: 20.5px;
  height: 28px;
  line-height: 28px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}
</style>
